import { useState, useEffect } from "react";

export interface Pitch {
  id: number;
  artistName: string;
  releaseTitle: string;
  releaseDate: string;
  configuration: string;
  focusTrackName: string;
  mainGenre: string;
  status: string;
  createdAt: string;
  updatedAt: string;
}

interface DraftPitchesData {
  pitches: Pitch[];
  totalItems: number;
}

const storageKey = "draft_pitches";

export const usePitchesStorage = () => {
  const [pitches, setPitches] = useState<Pitch[]>(() => {
    try {
      const stored = localStorage.getItem(storageKey);
      if (stored) {
        const data: DraftPitchesData = JSON.parse(stored);
        return data.pitches || [];
      }
      return [];
    } catch (error) {
      console.error("Error loading draft pitches from localStorage:", error);
      return [];
    }
  });

  useEffect(() => {
    const handleStorageChange = () => {
      try {
        const stored = localStorage.getItem(storageKey);
        if (stored) {
          const data: DraftPitchesData = JSON.parse(stored);
          setPitches(data.pitches || []);
        } else {
          setPitches([]);
        }
      } catch (error) {
        console.error("Error reading storage change:", error);
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  return { pitches };
};
